import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../utils/cn';

// Salesforce-style "Path" — connected chevron segments showing a record's
// progress through its stages. Completed stages are green with a check,
// the active stage is Salesforce blue and bold, everything after is neutral
// gray. Segments interlock via a clip-path arrow notch on the right edge and
// a matching negative margin on the following segment, so the row reads as
// one continuous strip rather than separate boxes.
const NOTCH = 14;

function chevronClipPath(isFirst) {
  const tip = `calc(100% - ${NOTCH}px) 0%, 100% 50%, calc(100% - ${NOTCH}px) 100%`;
  return isFirst
    ? `polygon(0% 0%, ${tip}, 0% 100%)`
    : `polygon(0% 0%, ${tip}, 0% 100%, ${NOTCH}px 50%)`;
}

export default function PathBar({ stages, currentIndex, onStageClick, disabled }) {
  return (
    <div className="flex w-full" role="list" aria-label="Stage progression">
      {stages.map((stage, idx) => {
        const isComplete = idx < currentIndex;
        const isCurrent = idx === currentIndex;
        return (
          <button
            key={stage.id}
            type="button"
            role="listitem"
            onClick={() => onStageClick(stage.id)}
            disabled={disabled}
            title={`Move to ${stage.label}`}
            className={cn(
              'relative flex-1 h-9 flex items-center justify-center gap-1.5 px-4 text-[11px] font-bold uppercase tracking-wide transition-colors whitespace-nowrap min-w-0 disabled:cursor-not-allowed',
              isCurrent ? 'bg-[#0176D3] text-white z-10' :
              isComplete ? 'bg-[#2E844A] text-white hover:bg-[#256b3c]' :
              'bg-[#F3F2F2] text-[#514F4D] hover:bg-[#E5E5E4]'
            )}
            style={{
              clipPath: chevronClipPath(idx === 0),
              marginLeft: idx === 0 ? 0 : -NOTCH,
            }}
          >
            {isComplete && <Check size={12} className="shrink-0" />}
            <span className="truncate">{stage.label}</span>
          </button>
        );
      })}
    </div>
  );
}
